import type { ConfigType, Dayjs } from 'dayjs'
import type { Duration } from 'dayjs/plugin/duration'

import { appDay } from './day'

const UNITS = ['year', 'month', 'week', 'day', 'hour', 'minute'] as const
type Unit = (typeof UNITS)[number]

function formatDuration(duration: Duration) {
	for (const unit of UNITS) {
		const value = duration.as(unit)
		if (value > 1) {
			return pluralize(value, unit)
		}
	}

	return ''
}

function genericOutput(date: Dayjs, compared: ConfigType, unit: Unit) {
	const diff = date.diff(compared, unit)
	return diff < 1 ? '' : pluralize(diff, unit)
}

function getRelativeFuture(input: ConfigType) {
	const asDay = appDay(input)
	const now = Date.now()

	if (!asDay.isAfter(now)) {
		return ''
	}

	for (const unit of UNITS) {
		const result = genericOutput(asDay, now, unit)
		if (result) {
			return result
		}
	}

	return ''
}

function pluralize(value: number, unit: Unit) {
	const unitString = value === 1 ? unit : `${unit}s`
	return `${value} ${unitString}`
}

export { formatDuration, getRelativeFuture }
